// APP_MODE controls the UI experience:
// - 'advanced': full-featured manager (current app)
// - 'basic': simplified light manager
const STORAGE_KEY = 'EA_APP_MODE';

export const isBasicMode    = () => (localStorage.getItem(STORAGE_KEY) ?? 'basic') === 'basic';
export const isAdvancedMode = () => !isBasicMode();

export const setAppMode = (mode) => localStorage.setItem(STORAGE_KEY, mode);
